import React, {useEffect} from "react";
import {DropdownItem, DropdownMenu, DropdownToggle, NavbarText, UncontrolledDropdown} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import {CompanyActions} from "../../Store/Company/Slice";
import {Company} from "../../Models/Company";
import {Customer} from "../../Models/Customer";
import {PickupActions} from "../../Store/Pickup/Slice";

const CompanyNameComponent = () => {

  const {
    authReducer: {user},
    CompanyReducer: {companies, company_selected, branch_selected, branchList}
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (companies?.length) {
      const {customer} = companies[0];
      dispatch(CompanyActions.setCompanySelected(customer));

      if (customer?.branch_company?.length) {
        dispatch(CompanyActions.setBranchSelected(customer.branch_company[0]));
        dispatch(CompanyActions.setBranchList(customer.branch_company));
      }
    }
  }, [companies, dispatch]);

  const handleCompanyName = (company: Customer) => {
    dispatch(CompanyActions.setCompanySelected(company));
    dispatch(CompanyActions.setBranchList(company.branch_company));
    if (company.branch_company.length) {
      dispatch(CompanyActions.setBranchSelected(company.branch_company[0]));
    } else {
      dispatch(CompanyActions.setBranchSelected({}));
    }
    dispatch(PickupActions.getPickups());
  };

  const handleBranchSelected = (branch: Customer) => {
    dispatch(CompanyActions.setBranchSelected(branch));
    dispatch(PickupActions.getPickups());
  };

  return (
    <>
      {
        companies?.length > 1 ?
        <UncontrolledDropdown className="mx-2" nav inNavbar>
          <DropdownToggle nav caret>
            Hola, {(company_selected as Customer)?.name}
          </DropdownToggle>
          <DropdownMenu right>
            {companies?.map((company: Company) => {

              return (
                <DropdownItem onClick={() => handleCompanyName(company?.customer)} key={company._KEY}>
                  {company?.customer?.name}
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </UncontrolledDropdown>
        :
        <NavbarText className="text-capitalize">
          Hola, {(company_selected as Customer)?.name || user?.name}
        </NavbarText>
      }

      {
        branchList.length > 1 ?
          <UncontrolledDropdown className="mx-2" nav inNavbar>
            <DropdownToggle nav caret>
              {(branch_selected as Customer)?.name}
            </DropdownToggle>
            <DropdownMenu right>
              {branchList?.map((branch: Customer) => {
                return (
                  <DropdownItem onClick={() => handleBranchSelected(branch)} key={branch._KEY}>
                    {branch?.name}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </UncontrolledDropdown>
          :
          <NavbarText className="text-capitalize">
            {(branch_selected as Customer)?.name || " "}
          </NavbarText>
      }
    </>
  );
};

export default CompanyNameComponent;
